export default __webpack_public_path__ + "static/media/oscer-pres-bleeding-generalised.77201198.svg";